import FreshlyFemaleImg from "../../assets/images/jpeg/freshlyFemaleImg.jpeg";
import FreshlyLogo from "../../assets/images/svg/freshlyWhiteLogo.svg";
import OmniLogo from "../../assets/images/png/omniActiveIcon.png";
import "./index.scss";

const MealServices = () => {
  return (
    <div className="meal-services">
      <div className="top-content">
        <img className="meal-left" src={FreshlyFemaleImg} alt="" />
        <div className="meal-right">
          <div className="container">
            <div className="top-row">
              <img className="freshly-logo" src={FreshlyLogo} alt="" />
              <img className="omni-logo" src={OmniLogo} alt="" />
            </div>
            <div className="text-content">
              <h2 className="heading">Nutritious Meals Made Easy</h2>
              <p className="bold-text">Unlock $125 off your first 5 orders</p>
              <p className="normal-text">
                Chef-crafted. Nutritionist-designed. Full-on delicious and delivered to your door.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="paragraphs">
        <p className="text-details">
          Omni-Active® Fitness, the leading brand for in-home, virtual, and online personal training, announces it's
          partnership with Freshly, one of the nation's leading meal delivery/food brands. The major goal of this unique
          partnership is to form a well-rounded approach to one's fitness that is anchored in convenience.
        </p>
        <p className="text-details">
          Omni-Active® clients will receive exclusive access to discounts using the Freshly platform. Once you're signed
          up, log in to our account and click on the "Meal Services" tab to claim your discount.
        </p>
      </div>
    </div>
  );
};

export default MealServices;
